$(document).ready(function () {
  "use strict";
  // navbar js start ---
  $(window).on("load scroll", function () {
    var scrolling = $(this).scrollTop();
    if (scrolling > 10) {
      $(".navbar").addClass("nav-fixed");
    } else {
      $(".navbar").removeClass("nav-fixed");
    }
  });

  $(".ham-menu, .sticky_category").click(function (event) {
    event.stopPropagation();
    $(".navbar-links-wrap").toggleClass("active");
    $(".ham-menu").toggleClass("active");
    $(".navbar-links-inner").toggleClass("active");
    $("body").toggleClass("active");
  });

  $(".mobile-menu-close-window-btn").click(function (event) {
    event.stopPropagation();
    $(".navbar-links-wrap").toggleClass("active");
    $(".ham-menu").toggleClass("active");
    $(".navbar-links-inner").toggleClass("active");
    $("body").toggleClass("active");
  });

  // mobile-dropdown responsive accordion js start--
  $(function () {
    let isMobile = window.matchMedia(
      "only screen and (max-width: 992px)"
    ).matches;

    if (isMobile) {
      $(".nav-links").slideUp();
      // **..mobile-dropdown-accordion js start..**
      $(".navbar-link-item-title").on("click", function () {
        $(this).next(".nav-links").slideToggle();
        $(this).parent().toggleClass("active");
        $(this)
          .parent()
          .siblings()
          .removeClass("active")
          .find(".nav-links")
          .slideUp();
      });
      // **..mobile-dropdown-accordion js end..**

      // **..mobile-dropdown-accordion js start..**
      $(".dropdown-btn2").on("click", function () {
        $(this).next(".dropdown-sub-menu2").slideToggle();
        $(this).toggleClass("active");
      });
      // **..mobile-dropdown-accordion js end..**
    }
  });
  // mobile-dropdown responsive accordion js end--

  $(".search-bar-open-btn").click(function (event) {
    event.stopPropagation();
    $(".search-bar").toggleClass("active");
    $(".search-bar-window-close-btn").toggleClass("active");

  });

  $(".search-bar-window-close-btn").click(function (event) {
    event.stopPropagation();
    $(".search-bar").toggleClass("active");
    $(this).toggleClass("active");

  });

  $(".search-close-btn").click(function (event) {
    event.stopPropagation();
    $(".search-bar").toggleClass("active");
    $(".search-bar-window-close-btn").toggleClass("active");

  });

  // navbar js end ---

  // footer-dropdown responsive accordion js start--
  $(function () {
    let isMobile = window.matchMedia(
      "only screen and (max-width: 575px)"
    ).matches;

    if (isMobile) {
      $(".footer-content").slideUp();
      // **..footer-dropdown-accordion js start..**
      $(".footer-item-title").on("click", function () {
        $(this).next(".footer-content").slideToggle();
        $(this).parent().toggleClass("active");
        $(this)
          .parent()
          .siblings()
          .removeClass("active")
          .find(".footer-content")
          .slideUp();
      });
      // **..footer-dropdown-accordion js end..**
    }
  });
  // footer-dropdown responsive accordion js end--

  // cart-sidebar js start---
  $(".side-cart-btn").click(function (event) {
    event.stopPropagation();
    $(".cart-sidebar").addClass("active");
    $(".cart-sidebar-box").addClass("active");
    $("body").addClass("active");

  });

  $(".cart-sidebar-close-window-btn").click(function (event) {
    event.stopPropagation();
    $(".cart-sidebar").removeClass("active");
    $(".cart-sidebar-box").removeClass("active");
    $("body").removeClass("active");


  });

  $(".side-cart-close-btn").click(function (event) {
    event.stopPropagation();
    $(".cart-sidebar").removeClass("active");
     $(".cart-sidebar-box").removeClass("active");
     $("body").removeClass("active");

  });

  $(".search_btn").click(function (event) {
    event.stopPropagation();
    $(".navbar-search-bar").toggleClass("active");
  });

  // Close when clicking outside
  $(document).on("click", function (event) {
    if (
      !$(event.target).closest(".navbar-search-bar, .search_btn").length
    ) {
      $(".navbar-search-bar").removeClass("active");
    }
  });
  // cart-sidebar js end---

  // collection filter sidebar js start--
  $(".filter-open-btn").click(function (event) {
    event.stopPropagation();
    $(".collection-filter").addClass("active");

  });

  $(".filter-window-close-btn").click(function (event) {
    event.stopPropagation();
    $(".collection-filter").removeClass("active");
    $("body").toggleClass("active");
  });

  $(".filter-close-btn").click(function (event) {
    event.stopPropagation();
    $(".collection-filter").removeClass("active");
    $("body").toggleClass("active");
  });
  // collection filter sidebar js end--

  // **..collection filter-accordion js start..**
  $(".accordion-toggle-btn").on("click", function () {
    $(this).next().slideToggle();
    $(this).parent().toggleClass("active");
  });
  // **..collection filter-accordion js end..**

  // **..product-accordion js start..**
  $(".product-accordion-toggle-btn").on("click", function () {
    $(this).next().slideToggle();
    $(this).parent().toggleClass("active");
    $(this)
      .parent()
      .siblings()
      .removeClass("active")
      .find(".product-accordion-item-content")
      .slideUp();
  });
  // **..product-accordion js end..**

  // size-chart-sidebar js start---
  $(".size-sidebar-btn").click(function (event) {
    event.stopPropagation();
    $(".size-chart-sidebar").toggleClass("active");
    $(".size-chart-sidebar-inner").toggleClass("active");
    $("body").toggleClass("active");
  });

  $(".size-chart-sidebar-close-window-btn").click(function (event) {
    event.stopPropagation();
    $(".size-chart-sidebar").removeClass("active");
    $(".size-chart-sidebar-inner").removeClass("active");
    $("body").removeClass("active");
  });

  $(".size-chart-close-btn").click(function (event) {
    event.stopPropagation();
    $(".size-chart-sidebar").removeClass("active");
    $(".size-chart-sidebar-inner").removeClass("active");
    $("body").removeClass("active");
  });
  // size-chart-sidebar js end---
      $(".quantity-increase").click(function () {
      // $("#quantity").val(parseInt($(".quantity-total").val()) + 1);
      $(".quantity-total, #variant_qty").val(parseInt($(".quantity-total").val()) + 1);

    });

    $(".quantity-decrease").click(function () {
      var currentValue = parseInt($(".quantity-total").val());
      if (currentValue > 1) {
        $(".quantity-total, #variant_qty").val(currentValue - 1);
        // $("#quantity").val(currentValue - 1);

        console.log('qty updated');
      }
    });

});

// btn js ---
// primary btn---
$(function () {
  $(".primary-btn")
    .on("mouseenter", function (e) {
      var parentOffset = $(this).offset(),
        relX = e.pageX - parentOffset.left,
        relY = e.pageY - parentOffset.top;
      $(this).find("span").css({
        top: relY,
        left: relX,
      });
    })
    .on("mouseout", function (e) {
      var parentOffset = $(this).offset(),
        relX = e.pageX - parentOffset.left,
        relY = e.pageY - parentOffset.top;
      $(this).find("span").css({
        top: relY,
        left: relX,
      });
    });
});

// secondary btn--
$(function () {
  $(".secondary-btn")
    .on("mouseenter", function (e) {
      var parentOffset = $(this).offset(),
        relX = e.pageX - parentOffset.left,
        relY = e.pageY - parentOffset.top;
      $(this).find("span").css({
        top: relY,
        left: relX,
      });
    })
    .on("mouseout", function (e) {
      var parentOffset = $(this).offset(),
        relX = e.pageX - parentOffset.left,
        relY = e.pageY - parentOffset.top;
      $(this).find("span").css({
        top: relY,
        left: relX,
      });
    });
});
// btn js ---

// hero slider js start--
var swiper = new Swiper(".hero-slider", {
  slidesPerView: 1,
  grabCursor: true,
  loop: true,
  speed: 1000,
  effect: "fade",
  autoplay: {
    delay: 3500,
    disableOnInteraction: false,
  },
  pagination: {
    el: ".hero-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".hero-button-next",
    prevEl: ".hero-button-prev",
  },
});
// hero slider js end--

// side-cart-slider js start--
var swiper = new Swiper(".side-cart-slider", {
  slidesPerView: 2.2,
  spaceBetween: 10,
  grabCursor: true,
  loop: false,
  speed: 1000,
});
// side-cart-slider js end--

// product-slider js start---
var swiper = new Swiper(".product-slider-thumb", {
  loop: true,
  spaceBetween: 20,
  slidesPerView: 5,
  freeMode: true,
  mousewheel: true,
  breakpoints: {
    // when window width is >= 320px
    1: {
      spaceBetween: 10,
      slidesPerView: 4,
    },
    // when window width is >= 576px
    576: {
      spaceBetween: 20,
      slidesPerView: 5,
    },
    // when window width is >= 767px
    768: {
      spaceBetween: 20,
      slidesPerView: 5,
    },
  },
});
var swiper2 = new Swiper(".product-slider", {
  loop: true,
  // autoHeight: true,
  spaceBetween: 10,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  thumbs: {
    swiper: swiper,
  },
});
// product-slider js end---

// related-product-slider js start--
var swiper = new Swiper(".related-product-slider", {
  slidesPerView: 4,
  spaceBetween: 20,
  grabCursor: true,
  loop: false,
  navigation: {
    nextEl: ".related-product-slider-btn-next",
    prevEl: ".related-product-slider-btn-prev",
  },
  breakpoints: {
    // when window width is >= 1px
    1: {
      spaceBetween: 10,
      slidesPerView: 1.7,
    },
    // when window width is >= 430px
    576: {
      spaceBetween: 20,
      slidesPerView: 2.3,
    },
    // when window width is >= 767px
    768: {
      spaceBetween: 20,
      slidesPerView: 3.2,
    },
    // when window width is >= 767px
    993: {
      spaceBetween: 20,
      slidesPerView: 4,
    },
  },
});
// related-product-slider js end--

// progesss-bar js start--
const progress = document.querySelector(".progress");
progress.addEventListener("input", function () {
  const value = this.value;
  this.style.background = `linear-gradient(to right,rgb(133 168 104) 0%,rgb(133 168 104) ${value}%,rgb(216, 216, 216) ${value}%)`;
});
// progesss-bar js end--


